import { isWKWebView } from './browser';
export function isMediaSourceSupported() {
    // WKWebView doesn't support MSE reliably even if the API exists
    if (isWKWebView) {
        return false;
    }
    return 'ManagedMediaSource' in window || 'MediaSource' in window;
}
export function isHlsSupported(video) {
    return video.canPlayType('application/vnd.apple.mpegurl') !== '';
}
export function isH265HVC1Supported(video) {
    return video.canPlayType('video/mp4; codecs="hvc1"') !== '';
}
export function isWebmVp9Supported(video) {
    return video.canPlayType('video/webm; codecs="vp9"') !== '';
}
export function isAV1CodecDecodingSupported() {
    var _a;
    if (!((_a = navigator.mediaCapabilities) === null || _a === void 0 ? void 0 : _a.decodingInfo)) {
        return Promise.resolve(false);
    }
    // checking fullhd 1080p at 30fps with 5Mbps bitrate
    const mediaConfig = {
        type: 'media-source',
        video: {
            contentType: 'video/mp4; codecs="av01.0.04M.08"',
            width: 1920,
            height: 1080,
            bitrate: 5000000,
            framerate: 30
        }
    };
    return navigator.mediaCapabilities
        .decodingInfo(mediaConfig)
        .then(result => result.supported && result.smooth);
}
